module.exports = __webpack_public_path__ + "708c94bd5ebc42de52a2454c876792b3.png";